/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
// ==============================================
// ==================Import======================
// ==============================================

// ==================react=================
import {
  forwardRef,
  useRef,
} from 'react';
import { useDispatch } from 'react-redux';

// ==================Actions=================
import { setGreaterInstallDate, setLessInstallDate } from '../../../actions/site';

export default forwardRef((props, ref) => {
  // HOOKS
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  // Remove precedent filter and save new value selected by user
  const onInputBoxChanged = (input) => {
    if (input.target.value === null) {
      dispatch(setGreaterInstallDate(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('equals', null);
      });
      return;
    }
    const dateGreaterInstall = input.target.value.split('-');
    const value = new Date(
      Number(dateGreaterInstall[0]),
      Number(dateGreaterInstall[1]) - 1,
      Number(dateGreaterInstall[2]),
    );
    dispatch(setGreaterInstallDate(input.target.value));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('greaterThan', value);
    });
  };

  const onInputLonBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(setLessInstallDate(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('equals', null);
      });
      return;
    }
    const dateGreaterInstall = input.target.value.split('-');
    const value = new Date(
      Number(dateGreaterInstall[0]),
      Number(dateGreaterInstall[1]) - 1,
      Number(dateGreaterInstall[2]),
    );
    dispatch(setLessInstallDate(input.target.value));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('lessThan', value);
    });
  };

  // styles
  const style = {
    color: props.color,
    width: '100%',
    maxHeight: '24px',
    margin: 'auto',
    marginTop: '0.2em',
    border: '1px solid gray',
    borderRadius: '3px',
    display: 'block',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div
      style={containerStyle}
    >
      <input
        placeholder="greater than ..."
        className="greaterInstallDate"
        ref={inputRef}
        style={style}
        type="text"
        onFocus={(e) => (e.target.type = 'date')}
        onBlur={(e) => (e.target.type = 'text')}
        onChange={onInputBoxChanged}
      />
      <input
        placeholder="less than ..."
        ref={inputRef}
        className="lessInstallDate"
        style={style}
        type="text"
        onFocus={(e) => (e.target.type = 'date')}
        onBlur={(e) => (e.target.type = 'text')}
        onChange={onInputLonBoxChanged}
      />
    </div>
  );
});
